export const ClockCheck = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 6v6l4 2"/>
    <path d="M22 12a10 10 0 1 0-11 9.95"/>
    <path d="m22 16-5.5 5.5L14 19"/>
  </svg>
);

export default ClockCheck;